import { useEffect, useRef, useState } from 'react';

export const useCareTeamCardDetails = () => {
  const [textWidth, setTextWidth] = useState(200);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      setTextWidth(containerRef.current.clientWidth);
    }
  }, [containerRef]);

  return {
    containerRef,
    textWidth,
  };
};
